import { Tutorial } from '../tutorial.model';

/**
 * O tour da listagem de clientes.
 *
 * Os cinco alvos foram escolhidos LENDO a tela (`clients-list.component.html`
 * e `components/filters/filters.component.html`): cada `alvo` abaixo tem um
 * `data-tour` correspondente num template de produção, e o portão
 * `tutorial-alvos.pure.spec.ts` reprova a suíte se algum deixar de ter.
 *
 * A ordem é a de USO da tela: achar (busca), recortar (filtros), criar (o
 * botão), agir sobre uma linha (ações), reordenar a tabela e, no fim, a
 * paginação — página a página e quantos por página (dono, 06/09/2026:
 * "aí fecha bem completo").
 * "Novo cliente" e as ações da linha dependem de permissão e de haver linha —
 * sem o elemento na tela, o motor pula o passo sozinho.
 */
export const CLIENTES_TOUR: Tutorial = {
  id: 'clientes',
  rota: '/painel/listagem/clientes',
  passos: [
    {
      alvo: 'clientes.busca',
      titulo: 'Encontre o cliente por qualquer dado',
      corpo:
        'A busca procura em nome ou razão social, nome fantasia, CPF e CNPJ. ' +
        'Pode digitar o documento com ou sem pontuação: os dois jeitos acham.',
      posicao: 'abaixo',
    },
    {
      alvo: 'clientes.filtros',
      titulo: 'Recorte por tipo e situação',
      corpo:
        'Aqui você escolhe ver só pessoa física, só pessoa jurídica ou só quem é domiciliado no exterior, ' +
        'e alterna entre clientes ativos, inativos ou todos. A lista abre mostrando só os ativos.',
      posicao: 'abaixo',
    },
    {
      alvo: 'clientes.novo',
      titulo: 'Cadastre um cliente novo',
      corpo:
        'Abre o cadastro completo: dados básicos, telefones, e-mails, contatos, endereços e documentos. ' +
        'Só nome e CPF ou CNPJ são obrigatórios.',
      posicao: 'abaixo',
    },
    {
      alvo: 'clientes.acoes',
      titulo: 'Tudo sobre um cliente fica na linha dele',
      corpo:
        'Ver a ficha, editar o cadastro ou inativar o cliente. Inativar não apaga nada: ' +
        'ele some das escolhas de conta a receber e pode ser reativado daqui.',
      posicao: 'esquerda',
    },
    {
      alvo: 'clientes.tabela',
      titulo: 'Ordene pelo nome',
      corpo: 'Clique no título da coluna para alternar entre ordem crescente e decrescente.',
      posicao: 'abaixo',
    },
    // Os dois últimos apontam para a PAGINAÇÃO, que é componente compartilhado
    // — por isso o contexto do alvo é `paginacao.` e não `clientes.`: o mesmo
    // elemento serve a toda listagem, e um nome de tela ali mentiria.
    {
      alvo: 'paginacao.paginas',
      titulo: 'Navegue entre as páginas',
      corpo:
        'A lista vem paginada. As setas vão para a página anterior e a seguinte, e os números ' +
        'saltam direto, inclusive para a primeira e a última.',
      posicao: 'acima',
    },
    {
      alvo: 'paginacao.tamanho',
      titulo: 'Escolha quantos por página',
      corpo:
        'Quantos clientes cabem em cada página. Aumentar ajuda a varrer a base de uma vez; ' +
        'diminuir deixa a tela mais leve em conexão ruim.',
      posicao: 'acima',
    },
  ],
};
